import { AUCTION_DETAIL_MODAL } from './constants'
import { hset, hdel } from '../../modules/hash'

export const openAuctionDetailModal = modalContent =>
  hset(AUCTION_DETAIL_MODAL, 'isOpen', modalContent)

export const closeAuctionDetailModal = () =>
  hdel(AUCTION_DETAIL_MODAL, 'isOpen')



// WEBPACK FOOTER //
// ./src/services/auction/actions.js